import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./app.css";

import mixpanel from "mixpanel-browser";
import TourWrapper from "./components/tutorial/TourWrapper";
import * as Sentry from "@sentry/react";
import { initMixpanel } from "./utils/analytics";
import { PostHogProvider } from "./components/analytics/PostHogProvider";

// PostHog configuration - replace with your actual API key
const POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_API_KEY || "phc_dqlU0a3LjKxUEbeYf4g14eDmJdZJY4TtILm5K7UIWFQ";
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com";

if (process.env.NODE_ENV === "production") {
  initMixpanel("e4f5abcdecbf83b881d5638e02353780", { track_pageview: true });
  Sentry.init({
    dsn: "https://ebbfb45db6a3c6cfbc41a234ff1ab34b@o4507301978308608.ingest.de.sentry.io/4507301980209232",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    tracePropagationTargets: ["localhost", /^https:\/\/wealthbee\.io\/api/],
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
} else {
  initMixpanel("XXXX");
}

//@Phil, need to discuss React.StrictMode as it causes double API calls in local
ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <PostHogProvider apiKey={POSTHOG_API_KEY} apiHost={POSTHOG_HOST}>
    <TourWrapper>
      <App />
    </TourWrapper>
  </PostHogProvider>
  // </React.StrictMode>
);
